import { ICommonIconProps } from "../types";

/**
 * -----------------------------------------------------------------------------
 * Renders a device with a protected badge/shield icon.
 */
export function DeviceProtectedIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M8.75 18.5H11.25"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M15 12.977V19C15 20.105 14.105 21 13 21H7C5.895 21 5 20.105 5 19V7C5 5.895 5.895 5 7 5H10.6"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.5 9.1031V7"
        stroke="currentColor"
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M13.499 10.5791C13.407 10.5791 13.332 10.6264 13.333 10.6845C13.333 10.742 13.408 10.7894 13.5 10.7894C13.592 10.7894 13.667 10.742 13.667 10.6839C13.667 10.6258 13.592 10.5791 13.499 10.5791Z"
        stroke="currentColor"
        strokeWidth={0.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.99483C10 10.6783 12.1184 11.9245 13.0607 12.3957C13.3373 12.5349 13.6635 12.5348 13.9399 12.3953C14.8826 11.9238 17 10.6806 17 8.99483V6.59783C16.9919 6.33626 16.7878 6.12294 16.5268 6.10341C15.6406 6.02207 14.7924 5.70486 14.0702 5.18474C13.73 4.93842 13.2701 4.93842 12.9298 5.18474C12.2077 5.70486 11.3594 6.02207 10.4732 6.10341C10.2122 6.12292 10.0081 6.33625 10 6.59783V8.99483Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
